/*
 * Delete-item.ts
 * Description: Includes the declaration
 * of function for deleting items
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

/**
 * Deleting an item from the cart
 *
 * @return {Object} Promise - refreshed cart
 * @param {Number} id - cart id
 * @param {String} slug - id of the restaurant
 */
export function deleteItem(id: number, slug: string) {
    const jwt = localStorage.getItem('jwt');
    const key = localStorage.getItem(slug);
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise ((resolve, reject) => {
        Axios({
            url:  APIURL + 'carts/' + id,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                guest_id: key,
            },
        }).then((response) => {
            resolve(response.data);
        }).catch(() => {
            reject();
        });
    });
}
